export default class EdgeRenderDataCache {
    constructor(selected, color, path) {
        this.selected = selected;
        this.color = color;
        this.path = path;
    }
    stateEquals(other) {
        return !!other && other.selected === this.selected && other.color === this.color;
    }
    pathEquals(other) {
        return !!other && !!other.path && !!this.path && other.path.hasSameValue(this.path);
    }
}
